import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Box } from '../Box/Box.js';
import { Typography } from '../Typography/Typography.js';
import { useDirectionContext } from '../../contexts/session/Locale.js';

var _excluded = ["title", "description", "fullWidthContent", "actionElement", "children"];
var Section = function Section(_ref) {
  var title = _ref.title,
    description = _ref.description,
    fullWidthContent = _ref.fullWidthContent,
    actionElement = _ref.actionElement,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var direction = useDirectionContext();
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "section"
  }, rest), /*#__PURE__*/React.createElement(Box, {
    p: "12"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justifyContent: "space-between",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Box, {
    width: "65%"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "heading-default"
  }, title)), /*#__PURE__*/React.createElement(Box, {
    width: "35%",
    pt: "4",
    ps: "12",
    textAlign: direction === 'rtl' ? 'left' : 'right'
  }, actionElement)), description && /*#__PURE__*/React.createElement(Typography, {
    variant: "body-s",
    mt: "4"
  }, description)), /*#__PURE__*/React.createElement(Box, {
    px: fullWidthContent ? undefined : '12',
    pb: "12"
  }, children));
};
Section.displayName = 'Section';

export { Section };
//# sourceMappingURL=Section.js.map
